const visibility = {
    name: "visibility",
    path: "/visibility",
    title: "visibility",
    description: "Utilities for controlling the visibility of an element.",
    value: {
        'visibility': {
          'visible': "visible",
          'invisible': "hidden",
          'collapse': "collapse",
        },

    },
    exampleData: [
        {
            "example": {
                "code": `
<div class="grid grid-cols-3 gap-4">
  <div>01</div>
  <div class="invisible ...">02</div>
  <div>03</div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<table>
  <thead>
    <tr>
      <th>Invoice #</th>
      <th>Client</th>
      <th>Amount</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>#100</td>
      <td>Pendant Publishing</td>
      <td>$2,000.00</td>
    </tr>
    <tr class="collapse">
      <td>#101</td>
      <td>Kruger Industrial Smoothing</td>
      <td>$545.00</td>
    </tr>
    <tr>
      <td>#102</td>
      <td>J. Peterman</td>
      <td>$10,000.25</td>
    </tr>
  </tbody>
</table>
                `
            },
        },
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">invisible </code>
                  utility to hide an element, but still maintain its place in the document, affecting the layout of other elements:
            </p>

                <div class="relative w-full rounded-lg">
                    <div class="absolute inset-0">
                        <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                    </div>
                    <div class="grid grid-columns-3 gap-4 font-mono text-sm leading-6 font-bold text-color-white relative z-10 p-4">
                        <div class="flex items-center justify-center rounded-lg  bg-color-violet-500 p-4">01</div>
                        <div class="invisible flex items-center justify-center rounded-lg  bg-color-violet-500 p-4">02</div>
                        <div class="flex items-center justify-center rounded-lg  bg-color-violet-500 p-4">03</div>
                    </div>
                </div>

            
            `
        },
         {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">collapse</code>
                  utility to hide table rows, row groups, columns, and column groups as if they were set to display: none, but without impacting the size of other rows and columns:
            </p>

            <table class="w-full border-collapse border-y border-color-gray-400 bg-color-white text-sm dark:border-color-gray-500 dark:bg-color-gray-800">
                <thead class="bg-color-gray-50 dark:bg-color-gray-700">
                    <tr>
                        <th class="border border-color-gray-300 px-4 py-3 text-left font-semibold text-gray-900 first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-600 dark:text-color-gray-200">Invoice #</th>
                        <th class="border border-color-gray-300 px-4 py-3 text-left font-semibold text-gray-900 first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-600 dark:text-color-gray-200">Client</th>
                        <th class="border border-color-gray-300 px-4 py-3 text-right font-semibold text-gray-900 first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-600 dark:text-color-gray-200">Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="border border-color-gray-300 px-4 py-3 text-color-gray-500 first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-700 dark:text-color-gray-400">#100</td>
                        <td class="border border-color-gray-300 px-4 py-3 text-color-gray-500 first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-700 dark:text-color-gray-400">Pendant Publishing</td>
                        <td class="border border-color-gray-300 px-4 py-3 text-right text-color-gray-500 tabular-nums first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-700 dark:text-color-gray-400">$2,000.00</td>
                    </tr>
                    <tr class="collapse">
                        <td class="border border-color-gray-300 px-4 py-3 text-color-gray-500 first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-700 dark:text-color-gray-400">#101</td>
                        <td class="border border-color-gray-300 px-4 py-3 text-color-gray-500 first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-700 dark:text-color-gray-400">Pendant Publishing</td>
                        <td class="border border-color-gray-300 px-4 py-3 text-right text-color-gray-500 tabular-nums first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-700 dark:text-color-gray-400">$2,000.00</td>
                    </tr>
                    <tr>
                        <td class="border border-color-gray-300 px-4 py-3 text-color-gray-500 first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-700 dark:text-color-gray-400">#102</td>
                        <td class="border border-color-gray-300 px-4 py-3 text-color-gray-500 first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-700 dark:text-color-gray-400">Pendant Publishing</td>
                        <td class="border border-color-gray-300 px-4 py-3 text-right text-color-gray-500 tabular-nums first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-700 dark:text-color-gray-400">$2,000.00</td>
                    </tr>
                </tbody>
            </table>        
            `
        },
    ]
};

export default visibility;

<div className="sr-only">
    <div class="grid grid-columns-3 inset-[3px] invisible collapse w-16 h-16 top-0 w-fit right-0 inset-y-0 inset-x-0 grid-rows-3 place-items-center gap-4 font-mono text-sm leading-6 font-bold text-color-white">
                <div class="relative size-18 rounded-lg sm:size-32">
                    <div class="absolute inset-0">
                        <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                    </div>
                    <div class="absolute top-0 left-0 -top-4 -left-4 flex size-10 items-center justify-center rounded-lg bg-color-violet-500 p-4">01</div>
                </div>
                
            </div>  

            <table class="w-full border-collapse border-y border-color-gray-400 bg-color-white text-sm dark:border-color-gray-500 dark:bg-color-gray-800">
                <thead class="bg-color-gray-50 dark:bg-color-gray-700">
                    <tr>
                        <th class="border border-color-gray-300 px-4 py-3 text-left font-semibold text-gray-900 first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-600 dark:text-color-gray-200">Invoice #</th>
                        <th class="border border-color-gray-300 px-4 py-3 text-left font-semibold text-gray-900 first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-600 dark:text-color-gray-200">Client</th>
                        <th class="border border-color-gray-300 px-4 py-3 text-right font-semibold text-gray-900 first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-600 dark:text-color-gray-200">Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="border border-style-dashed border-color-gray-300 px-4 py-3 text-color-gray-500 first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-700 dark:text-color-gray-400">#100</td>
                        <td class="border border-color-gray-300 px-4 py-3 text-color-gray-500 first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-700 dark:text-color-gray-400">Pendant Publishing</td>
                        <td class="border border-color-gray-300 px-4 py-3 text-right text-color-gray-500 tabular-nums first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-700 dark:text-color-gray-400">$2,000.00</td>
                    </tr>
                    <tr class="collapse">
                        <td class="border border-color-gray-300 px-4 py-3 text-color-gray-500 first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-700 dark:text-color-gray-400">#101</td>
                        <td class="border border-color-gray-300 px-4 py-3 text-color-gray-500 first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-700 dark:text-color-gray-400">Pendant Publishing</td>
                        <td class="border border-color-gray-300 px-4 py-3 text-right text-color-gray-500 tabular-nums first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-700 dark:text-color-gray-400">$2,000.00</td>
                    </tr>
                    <tr>
                        <td class="border border-color-gray-300 px-4 py-3 text-color-gray-500 first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-700 dark:text-color-gray-400">#102</td>
                        <td class="border border-color-gray-300 px-4 py-3 text-color-gray-500 first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-700 dark:text-color-gray-400">Pendant Publishing</td>
                        <td class="border border-color-gray-300 px-4 py-3 text-right text-color-gray-500 tabular-nums first:border-l-w-0 last:border-r-w-0 dark:border-color-gray-700 dark:text-color-gray-400">$2,000.00</td>
                    </tr>
                </tbody>
            </table>
</div>